module.exports = __webpack_public_path__ + "img/patrones.b9929807.webp";